/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { message } from 'antd';

import { ErrorStatusMessages } from './constants';

export interface IAppErrorParams {
  duration?: number;
  errorMessage?: string;
}

export type AppErrorParamsType = number | string | IAppErrorParams;

export const DEFAULT_ERROR_MESSAGE =
  'Something went wrong. Please try again later.';
export const DEFAULT_ERROR_MESSAGE_DURATION = 3;

const getErrorMessage = (
  messages: any[],
  code: number,
  fallbackErrorMessage?: string,
): string => {
  let errorMessage = messages.find(
    (msg) =>
      msg &&
      (typeof msg === 'string' || (Array.isArray(msg) && msg.length > 0)),
  );

  if (Array.isArray(errorMessage)) {
    errorMessage = errorMessage.join(', ');
  }

  // if error status code is 400 or higher and no valid message is found, use the standard status based error message
  // or, show generalised error message based on specific error status codes (401 - Unauthorized, 403 - Forbidden, 429 - Too Many Requests)
  if ((code >= 400 && !errorMessage) || [401, 403, 429].includes(code)) {
    errorMessage =
      ErrorStatusMessages[code as keyof typeof ErrorStatusMessages];
  }

  return errorMessage || fallbackErrorMessage || DEFAULT_ERROR_MESSAGE;
};

/**
 * This function is used to show error message to the user where custom error message should be passed as a fallback message for the user's better understanding if the API fails.
 * @param error - error object from the API response or the error message
 * @param params - duration or custom error message or both in a object (type: number | string | {
  duration?: number;
  errorMessage?: string;
})
 * @returns void
 * @example
 * showAppError('Something went wrong');
 * showAppError('Something went wrong', 3);
 * showAppError('Something went wrong', 'Custom error message'); 
 */

const showAppError = (error: any, params?: AppErrorParamsType) => {
  // error = {response}

  // console.log('response:', error.response);

  // don't show error message if error status code is 401 (unauthorized)
  if (error?.code === 401 || error?.status === 401) {
    return;
  }

  const errorResp = error?.response;
  const errorStatusCode = (error?.status ||
    error?.code) as keyof typeof ErrorStatusMessages;

  console.log(
    'error:',
    error,
    'errorResp:',
    errorResp,
    'errorStatusCode:',
    errorStatusCode,
  );

  let errorMessage = DEFAULT_ERROR_MESSAGE;
  const fallbackErrorMessage =
    typeof params === 'object' && params.errorMessage
      ? params.errorMessage
      : (typeof params === 'string' && params) || '';

  // if error = {code, type, result, message}
  // handle 0 as it is the success code (OK) of our backend
  if (error?.code >= 400 || error?.code !== 0) {
    errorMessage = getErrorMessage(
      [
        error?.result?.message,
        error?.result,
        // error.message,
      ],
      error.code,
      fallbackErrorMessage,
    );
  }

  // if default error
  if (errorResp?.status >= 400) {
    errorMessage = getErrorMessage(
      [
        // errorResp?.data?.error,
        errorResp?.data?.result?.message,
        errorResp?.data?.result,
        errorResp?.result?.message,
        errorResp?.result,
        errorResp?.data?.message,
        // errorResp?.message,
      ],
      errorResp?.status,
      fallbackErrorMessage,
    );
  }

  const finalErrorMessage = typeof error === 'string' ? error : errorMessage;

  console.log('errorMessage:', finalErrorMessage);

  // show error message to the user
  message.error({
    content: finalErrorMessage,
    duration:
      typeof params === 'object' && params.duration
        ? params.duration
        : (typeof params === 'number' && params) ||
          DEFAULT_ERROR_MESSAGE_DURATION,
    key: 'errorAlert',
    type: 'error',
  });
};

export default showAppError;
